import { h, render } from 'preact'
import { BlogCard } from 'sections/blog/BlogCard'

function TableOfContents({ mobile }) {
  const headingList = document.querySelectorAll('.article-content h2')
  const scrollToHeading = (heading) => {
    setTimeout(() => {
      const rect = heading.getBoundingClientRect()
      const absoluteTop = rect.top + window.pageYOffset
      window.scrollTo({
        top: absoluteTop - 20
      })
    }, 10)
  }

  return (
    Array.from(headingList).map((heading) => (
      <a href='#' onClick={() => scrollToHeading(heading)} key={heading.innerText} className={`btn-s btn-text btn-primary ${mobile ? 'shrink-0' : ''}`}>
        {heading.innerText}
      </a>
    ))
  )
}

function TableOfContentsMobile () {
  return (
    <div className='p-margin flex flex-row flex-nowrap gap-x-1 overflow-x-scroll no-scrollbar'>
      <TableOfContents mobile />
    </div>
  )
}

function RelatedArticles ({ currentArticleID, metafieldArticles = [] }) {
  const { handle: blogHandle, articles = [] } = window.globals?.currentBlog || {}

  if (!currentArticleID || !articles.length) return null
  let relatedArticles
  if (metafieldArticles.length > 0) {
    relatedArticles = metafieldArticles
      .map((handle) => {
        const fullHandle = `${blogHandle}/${handle}`
        return articles.find((article) => article.handle === fullHandle)
      })
  } else {
    relatedArticles = articles
      .filter((article) => `${article.id}` !== `${currentArticleID}`)
      .slice(0, 3)
  }

  return (
    <>
      {relatedArticles.map((article) => (
        <BlogCard key={article.id} blog={article} />
      ))}
    </>
  )
}

document.addEventListener('DOMContentLoaded', () => {
  const TOCContainer = document.querySelector('.table-of-contents')
  const TOCMobileContainer = document.querySelector('.table-of-contents--mobile')
  if (TOCContainer) {
    render(<TableOfContents />, TOCContainer)
    render(<TableOfContentsMobile />, TOCMobileContainer)
  }

  const relatedArticlesContainer = document.querySelector('.related-articles-container')
  if (relatedArticlesContainer) {
    const currentArticleID = relatedArticlesContainer.dataset.currentArticleId || ''
    const metafieldArticles = JSON.parse(relatedArticlesContainer.dataset.metafieldArticles) || []
    render(<RelatedArticles currentArticleID={currentArticleID} metafieldArticles={metafieldArticles} />, relatedArticlesContainer)
  }
})
